import { __spreadValues } from './chunk-5JBD5THX.js';
import * as React from 'react';

var SvgChevronDown = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues({ viewBox: "0 0 16 16", fill: "none" }, props), /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M3 6L7.11612 10.1161C7.53278 10.5328 7.74112 10.7411 8 10.7411C8.25888 10.7411 8.46722 10.5328 8.88388 10.1161L13 6",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
));
var ChevronDown_default = SvgChevronDown;

export { ChevronDown_default };
